/**
 * @generated SignedSource<<bdd8b5e05deb163f7f2c2dc0bb68f9e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PieceRendererViewOriginalImageQuery$variables = {
  job_id: string;
};
export type PieceRendererViewOriginalImageQuery$data = {
  readonly music_viewer: {
    readonly note_original_image_extractor: {
      readonly image_download_url: string | null;
      readonly job_id: string;
      readonly job_status: string;
    };
  };
};
export type PieceRendererViewOriginalImageQuery = {
  variables: PieceRendererViewOriginalImageQuery$variables;
  response: PieceRendererViewOriginalImageQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "job_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MusicViewer",
    "kind": "LinkedField",
    "name": "music_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "job_id",
            "variableName": "job_id"
          }
        ],
        "concreteType": "MusicNoteOriginalImageExtractor",
        "kind": "LinkedField",
        "name": "note_original_image_extractor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image_download_url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "job_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "job_status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PieceRendererViewOriginalImageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PieceRendererViewOriginalImageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1f378e03f915a342cf916b8d41f5cfd7",
    "id": null,
    "metadata": {},
    "name": "PieceRendererViewOriginalImageQuery",
    "operationKind": "query",
    "text": "query PieceRendererViewOriginalImageQuery(\n  $job_id: ID!\n) {\n  music_viewer {\n    note_original_image_extractor(job_id: $job_id) {\n      image_download_url\n      job_id\n      job_status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa69eeb43ee46f34a5e92e86cf513199";

export default node;
